export default "__VITE_ASSET__BwK0fLw8__"